import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var CheckboxGroupsChangeModelLazy = /*#__PURE__*/function () {
  function CheckboxGroupsChangeModelLazy(checkboxGroupChangeModel, calcAllItems) {
    _classCallCheck(this, CheckboxGroupsChangeModelLazy);

    _defineProperty(this, "checkboxGroupChangeModel", void 0);

    _defineProperty(this, "calcAllItems", void 0);

    _defineProperty(this, "_allItems", void 0);

    this.checkboxGroupChangeModel = checkboxGroupChangeModel;
    this.calcAllItems = calcAllItems;
  }

  _createClass(CheckboxGroupsChangeModelLazy, [{
    key: "allItems",
    get: function get() {
      var _this$_allItems;

      (_this$_allItems = this._allItems) !== null && _this$_allItems !== void 0 ? _this$_allItems : this._allItems = this.calcAllItems();
      return this._allItems;
    }
  }]);

  return CheckboxGroupsChangeModelLazy;
}();